<template>
  <div>
    <dashboard-page-title :showFilter="true" :showSearch="true" :showExportation="true" :showAddBtn="false">السائقين</dashboard-page-title>

    <main-table :fields="fields" :baseURL="VUE_APP_TRANSPORTATION_LINK" :status-url="'drivers/status'" :list_url="'drivers'"></main-table>
  </div>
</template>
<script>
import { core } from '@/config/pluginInit'
import { VUE_APP_TRANSPORTATION_LINK } from '@/config/constant'
export default {
  name: 'offDrivers',
  mounted () {
    core.index()
  },
  data () {
    return {
      VUE_APP_TRANSPORTATION_LINK,
      fields: [
        { label: 'اسم السائق', key: 'name', type: 'name', class: 'text-right' },
        { label: ' الشركة التابع لها', key: 'company', type: 'name', class: 'text-right' },
        { label: 'عدد الرحلات', key: 'numberOfTrips', class: 'text-right' },
        { label: 'التقييم', key: 'rate', type: 'number', class: 'text-right' },
        { label: 'الأرباح', key: 'profits', class: 'text-right' },
        {
          label: 'الحالة', key: 'change_status'
        }
      ]
    }
  },
  methods: {
    addMerchant () {
      console.log('hello')
    }
  }
}
</script>
